import gsap from 'gsap';
import barba from '@barba/core';

let currentClone = null;

// imgOverride : image de départ explicite (ex. le cadre du sommaire de la home)
export const startArticleTransition = (articleElement, imgOverride = null) => {
    const img = imgOverride || articleElement.querySelector('img');

    if (!img) return console.warn('No image found in article');

    const url = articleElement.dataset.url || articleElement.querySelector('a')?.href;
    if (!url) return console.warn('No URL found for article transition');

    // Cleanup d'un éventuel clone orphelin avant d'en créer un nouveau
    cleanupArticleClone();

    const rect = img.getBoundingClientRect();

    currentClone = img.cloneNode(true);
    currentClone.style.cssText = `
        position: fixed;
        top: ${rect.top}px;
        left: ${rect.left}px;
        width: ${rect.width}px;
        height: ${rect.height}px;
        object-fit: cover;
        object-position: center;
        z-index: 9999;
        pointer-events: none;
    `;
    document.body.appendChild(currentClone);

    const closestSection = articleElement.closest('#hz-slide-01, #hz-slide-02, #home-stage, #home-index, #latest-works, #grid-wrapper');

    sessionStorage.setItem('transition_image', JSON.stringify({
        src:  img.currentSrc || img.src,
        rect: { top: rect.top, left: rect.left, width: rect.width, height: rect.height }
    }));
    sessionStorage.setItem('transition_type',    'article');
    sessionStorage.setItem('transition_referer', window.location.href);
    sessionStorage.setItem('transition_scroll',  String(window.scrollY));
    sessionStorage.setItem('transition_section', closestSection?.id || '');

    gsap.to(currentClone, {
        top: 0, left: 0, width: '100vw', height: '100vh',
        duration: 0.85,
        ease: 'power3.inOut',
        onComplete: () => {
            // FIX : le clone couvre tout le viewport à ce stade.
            // On masque le container source MAINTENANT, de façon atomique,
            // avant que barba.go() ne déclenche leave() — évite tout flash
            // du fond de la page source pendant la transition.
            const currentContainer = document.querySelector('[data-barba="container"]');
            if (currentContainer) gsap.set(currentContainer, { opacity: 0 });

            barba.go(url);
        },
    });
};

export const startArticleReturnTransition = () => {
    const returnUrl = sessionStorage.getItem('transition_referer');

    if (returnUrl) {
        barba.go(returnUrl);
    } else {
        history.back();
    }
};

export const cleanupArticleClone = () => {
    if (currentClone) {
        currentClone.remove();
        currentClone = null;
    }
};